angular.module('unica_media_upload.media_services')

.factory('MediaUploadEditService', function ($http, getBaseApiURL, getBaseWebURL) {

	var mediaEditService = {};

	mediaEditService.updateStatus = function (id, mediaData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-upload/update-status/' + id,
			data: mediaData
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.approveMedia = function (id)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-upload/approve/' + id,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.declineMedia = function (id)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-upload/decline/' + id,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	return mediaEditService;
});